import DriverInfoCell from './component';
import { compose } from 'recompose';
import { connect } from 'react-redux';

import { withJourneyCardSelectors } from 'modules/journey/card/hoc';

const fields = ['isInvalidVehicle', 'dedicated_contract', 'driver'];

const enhance = compose(
  withJourneyCardSelectors,
  connect((state, props) => {
    const {
      isInvalidVehicle: isUnsuitable,
      dedicated_contract: isDedicated,
      driver,
    } = props.selectors.getJourneyFields(state, props.journeyId, fields);

    return {
      isDedicated,
      isUnsuitable,
      isFleetService: driver?.is_fleet_service,
      isFTC: driver?.is_ftc,
    };
  })
);

export default enhance(DriverInfoCell);
